import { h } from 'preact';
import { _className } from '../../../utils/classname.utils';
import style from './Button.css';

const ButtonType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
};
const ButtonSize = { LARGE: 'large', SMALL: 'small' };
const ButtonComponent = { LINK: 'a', BUTTON: 'button' };

const CustomButton = ({ component, children, ...props }) => {
  const items = {
    [ButtonComponent.LINK]: <a {...props}> {children}</a>,
    [ButtonComponent.BUTTON]: <button {...props}>{children}</button>,
  };
  return items[component] || items[ButtonComponent.BUTTON];
};

export default function Button({
  className = '',
  type = ButtonType.PRIMARY,
  size = ButtonSize.LARGE,
  component = ButtonComponent.BUTTON,
  fullWidth = false,
  children,
  ...props
}) {
  return (
    <CustomButton
      component={component}
      className={`${className} ${style.button} ${style[type]} ${
        style[size]
      } ${_className(fullWidth, style['full-width'])}`}
      {...props}
    >
      {children}
    </CustomButton>
  );
}

Button.Type = ButtonType;
Button.Size = ButtonSize;
Button.Component = ButtonComponent;
